export const synonymQueryKeys = {
    all: (agentId: number) => ["page-synonym", "agent", agentId]
} as const;
